import type { OpportunityInputs } from './leadOpportunity';
export type CallbackRequest = {
  leads?: string;
  email?: string;
  calculator?: OpportunityInputs;
  marketingConsent?: boolean;
} & (
  | { source: 'book_calculator'; name?: string; phone?: string }
  | { source: 'final_cta' | 'scroll_depth_cta' | 'book_lead'; name: string; phone: string }
);
export async function submitCallback(payload: CallbackRequest, send: typeof fetch = fetch): Promise<void> {
  const response = await send('/api/callback', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload), signal: AbortSignal.timeout(12000),
  });
  if (!response.ok) throw new Error('Callback delivery not confirmed');
  const result = await response.json();
  if (result?.ok !== true) throw new Error('Callback delivery not confirmed');
}
